import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import icons from "../../assets/images/constantIcons";
import Navbar from "./Navbar";
import { useDispatch, useSelector } from "react-redux";
import { getMenusDetails } from "./MenusSlice";
import { getCart, setCart } from "../store/utils";
import { allOrders } from "./OrderSlice";
import { PacmanLoader } from "react-spinners";

const Menus = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const { menu, loading } = useSelector((state) => state.menus);
  const [cartItems, setCartItems] = useState(getCart());
  const { orders = [] } = useSelector((state) => state.orders || {});
  const hasToken = () => !!localStorage.getItem("canteenToken");
  const [tabs, setTabs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    dispatch(allOrders())
  }, [dispatch])

  useEffect(() => {
    dispatch(getMenusDetails(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (menu && (Array.isArray(menu.categories) || menu.combo_offer_categories)) {
      const allTabs = [
        ...(Array.isArray(menu.categories)
          ? menu.categories.map((cat) => ({
            id: cat.id,
            name: cat.name,
            type: "category",
            items: cat.items,
          }))
          : []),
        ...(menu.combo_offer_categories
          ? [
            {
              id: menu.combo_offer_categories.id,
              name: menu.combo_offer_categories.name,
              type: "combo",
              items: menu?.combo_offer_categories?.canteen_combo_offers_filtered?.map(
                (combo, i) => ({
                  id: i,
                  name: combo.combo_offer_name,
                  description: combo.combo_description,
                  items: combo.combo_items,
                  image: combo.image_url || null,
                  price: combo.price || 0,
                  stock_quantity: combo.stock_quantity ?? 100,
                  stock_available: combo.stock_quantity !== 0,
                })
              ),
            },
          ]
          : []),
      ];

      setTabs(allTabs);
      setSelectedCategory(allTabs[0]);
    }
  }, [menu]);


  useEffect(() => {
    if (menu.length > 0) {
      setSelectedCategoryId(menu[0].id);
    }
  }, [menu]);

  useEffect(() => {
    setCart(cartItems);
  }, [cartItems]);

  const handleAdd = (item) => {
    setCartItems((prev) => ({
      ...prev,
      [item.id]: { ...item, quantity: 1 },
    }));
  };

  const handleIncrease = (item) => {
    setCartItems((prev) => ({
      ...prev,
      [item.id]: { ...prev[item.id], quantity: prev[item.id].quantity + 1 },
    }));
  };

  const handleDecrease = (item) => {
    setCartItems((prev) => {
      const updated = { ...prev };
      if (updated[item.id].quantity === 1) {
        delete updated[item.id];
      } else {
        updated[item.id].quantity -= 1;
      }
      return updated;
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

  if (loading) return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
      <PacmanLoader color="#85bd3a" size={40} />
    </div>
  );

  return (
    <>
      <Navbar />
      <div className="flex flex-col bg-white h-[88vh] overflow-y-auto vertical">
        <div className="sticky top-0 z-20 bg-white">
          <div className="px-10 pt-4 ">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-3xl font-bold text-G800">Menus</h1>
            </div>
            {/* categories */}
            <div className="flex gap-10 text-G800 font-semibold border-b border-G20 overflow-x-auto">
              {tabs.map((tab, index) => (
                <p
                  key={index}
                  onClick={() => setSelectedCategory(tab)}
                  className={`cursor-pointer py-2 text-nowrap ${selectedCategory?.id === tab.id && selectedCategory?.type === tab.type
                    ? "text-canteengreen border-b-2 border-canteengreen"
                    : ""
                    }`}
                >
                  {tab.name}
                </p>
              ))}
            </div>
          </div>
        </div>

        <section className="px-10 z-10 mt-2">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-semibold flex items-center gap-2 my-3">
              Choose Dishes
            </h2>
          </div>

          {selectedCategory?.type === "category" ? (
            selectedCategory.items.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                {selectedCategory.items.map((dish, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg shadow-md text-center border p-4"
                  >
                    <div className="flex justify-center py-3 items-center rounded-lg bg-canteencardcolor mb-3">
                      <img
                        src={`https://headquater.pixoatic.com${dish.image}`}
                        alt={dish.name}
                        loading="lazy"
                        className="w-32 h-32 rounded-full object-fill"
                      />
                    </div>
                    <div>
                      <p className="text-xl font-semibold mb-3 text-left mr-11">
                        {dish.name.replace(/\b\w/g, (char) => char.toUpperCase())}
                      </p>
                      <div className="flex justify-between items-center">
                        <p className="text-G800 text-[22px] font-bold mb-2">
                          <span className="text-canteengreen">₹ </span>{" "}
                          {Math.trunc(dish.price)}
                        </p>
                        {dish.stock_quantity === 0 ? (
                          <div className="text-red text-sm font-semibold px-3 py-1">
                            Out of Stock
                          </div>
                        ) : cartItems[dish.id]?.quantity > 0 ? (
                          <div className="flex items-center gap-3 border border-canteengreen text-G700 rounded-lg px-2 py-1 text-sm font-semibold">
                            <button onClick={() => handleDecrease(dish)}>-</button>
                            <span>{cartItems[dish.id].quantity}</span>
                            <button
                              onClick={() => handleIncrease(dish)}
                              disabled={
                                cartItems[dish.id].quantity >= dish.stock_quantity
                              }
                              className={
                                cartItems[dish.id].quantity >= dish.stock_quantity
                                  ? "text-gray-400 cursor-not-allowed"
                                  : ""
                              }
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => handleAdd(dish)}
                            className="bg-canteengreen text-white px-4 h-8 font-semibold rounded-lg text-xs"
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-G800 mt-8">
                No items available for this category.
              </p>
            )
          ) : selectedCategory?.type === "combo" ? (
            selectedCategory.items?.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                {selectedCategory.items.map((combo, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg shadow-md text-center border p-4"
                  >
                    <div className="flex justify-center py-3 items-center rounded-lg bg-canteencardcolor mb-3">
                      <img
                        src={
                          combo.image
                            ? `https://headquater.pixoatic.com${combo.image}`
                            : "https://via.placeholder.com/100"
                        }
                        alt={combo.name}
                        loading="lazy"
                        className="w-32 h-32 rounded-full object-fill"
                      />
                    </div>
                    <div>
                      <p className="text-xl font-semibold mb-1 text-left">{combo.name}</p>
                      <p className="text-sm text-left text-gray-500 mb-2">{combo.description}</p>
                      <ul className="list-disc list-inside text-left text-sm text-gray-700 mb-3">
                        {combo.items?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                      <div className="flex justify-between items-center">
                        <p className="text-G800 text-[22px] font-bold mb-2">
                          <span className="text-canteengreen">₹ </span>{" "}
                          {Math.trunc(combo.price)}
                        </p>
                        {combo.stock_quantity === 0 ? (
                          <div className="text-red text-sm font-semibold px-3 py-1">
                            Out of Stock
                          </div>
                        ) : cartItems[combo.id]?.quantity > 0 ? (
                          <div className="flex items-center gap-3 border border-canteengreen text-G700 rounded-lg px-2 py-1 text-sm font-semibold">
                            <button onClick={() => handleDecrease(combo)}>-</button>
                            <span>{cartItems[combo.id].quantity}</span>
                            <button
                              onClick={() => handleIncrease(combo)}
                              disabled={
                                cartItems[combo.id].quantity >= combo.stock_quantity
                              }
                              className={
                                cartItems[combo.id].quantity >= combo.stock_quantity
                                  ? "text-gray-400 cursor-not-allowed"
                                  : ""
                              }
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => handleAdd(combo)}
                            className="bg-canteengreen text-white px-4 h-8 font-semibold rounded-lg text-xs"
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-G800 mt-8">
                No combo offers available.
              </p>
            )
          ) : null}

        </section>


        {hasToken() ? (
          <section className="px-10 z-10  my-5 ">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-semibold flex items-center gap-2 my-3">
                Orders
              </h2>
              <Link to="/allOrders">
                <p className="border border-canteengreen rounded-md text-canteengreen cursor-pointer px-4 py-1 hover:bg-canteengreen hover:text-white">view all</p>
              </Link>
            </div>
            {orders?.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                {orders?.slice(0, 6).map((order, index) => (
                  <div key={index} className={`${order.status === "pending" ? "bg-canteencardcolor" : order.status === "completed" ? "bg-[#E6F4EA]" : "bg-[#db392f30]"} rounded-2xl p-4 flex flex-col justify-between border-2 border-canteencardcolor`}>
                    <div className="flex justify-between text-G500">
                      <p className="text-lg font-semibold">
                        Order ID <span>{order.order_uniq_id}</span>
                      </p>
                      <p className="text-sm font-medium">{order.user.full_name}</p>
                    </div>
                    <div className="flex justify-between text-G100 text-xs mt-2">
                      <p>{formatDate(order.date)}</p>
                      <p className="bg-white  text-canteengreen rounded-lg px-2 py-1">
                        Customer
                      </p>
                    </div>
                    <div className="flex flex-col gap-2 text-G500 text-sm my-2 max-h-32 overflow-y-auto vertical">
                      {order.order_items.map((item, idx) => (
                        <div
                          key={idx}
                          className="flex justify-between items-center gap-3"
                        >
                          <div className="flex items-center justify-between ">
                            <p className="w-56 flex items-center">
                              <img
                                src={item.image}
                                alt={item.item_name}
                                className="w-8 h-8 rounded-full mr-3"
                              />
                              {item.item_name}
                            </p>
                            <h1>X{item.quantity}</h1>
                          </div>
                          <div className="font-medium">₹ {item.total_price}</div>
                        </div>
                      ))}
                    </div>
                    <div className="mt-auto">
                      <hr className="border-b-[1px] border-white mb-2" />
                      <div className="flex justify-between items-center text-G500">
                        <p className="font-semibold text-lg flex">
                          <span className="text-canteengreen mr-1">₹</span>
                          {order.total_price}
                        </p>
                        <div className={`text-center text-sm py-[6px] px-4 rounded-md bg-white ${order.status === "pending" ? "text-yellow" : "text-green"}`}>
                          {order.status}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (<p>No orders available</p>)}
          </section>) : (<></>)}
      </div>
      {Object.keys(cartItems).length > 0 && (
        <Link to="/cartOrders" className="flex items-center gap-2 font-semibold ">
          <div className="fixed  bottom-3 w-full shadow-lg border border-canteencardcolor rounded-md bg-canteengreen text-white flex justify-between items-center px-6 py-3 z-10">
            <span>{Object.values(cartItems).reduce((acc, item) => acc + item.quantity, 0)} items</span>
            <div className="flex gap-3"><icons.PiShoppingCart className="text-xl font-semibold" /> View Cart</div>
          </div>
        </Link>
      )}
    </>
  );
};

export default Menus;
